module.exports = __webpack_public_path__ + "img/search.580a335a.svg";